export const ADMIN_GET_USERS_REQUEST = 'ADMIN_GET_USERS_REQUEST';
export const ADMIN_GET_USERS_SUCCESS = 'ADMIN_GET_USERS_SUCCESS';
export const ADMIN_GET_USERS_ERROR = 'ADMIN_GET_USERS_ERROR';

export const ADMIN_GET_CATEGORIES_REQUEST = 'ADMIN_GET_CATEGORIES_REQUEST';
export const ADMIN_GET_CATEGORIES_SUCCESS = 'ADMIN_GET_CATEGORIES_SUCCESS';
export const ADMIN_GET_CATEGORIES_ERROR = 'ADMIN_GET_CATEGORIES_ERROR';

export const ADMIN_GET_DOCUMENTS_REQUEST = 'ADMIN_GET_DOCUMENTS_REQUEST';
export const ADMIN_GET_DOCUMENTS_SUCCESS = 'ADMIN_GET_DOCUMENTS_SUCCESS';
export const ADMIN_GET_DOCUMENTS_ERROR = 'ADMIN_GET_DOCUMENTS_ERROR';

export const ADMIN_ADD_DOCUMENT_REQUEST = 'ADMIN_ADD_DOCUMENT_REQUEST';
export const ADMIN_ADD_DOCUMENT_SUCCESS = 'ADMIN_ADD_DOCUMENT_SUCCESS';
export const ADMIN_ADD_DOCUMENT_ERROR = 'ADMIN_ADD_DOCUMENT_ERROR';

export const ADMIN_DELETE_DOCUMENT_REQUEST = 'ADMIN_DELETE_DOCUMENT_REQUEST';
export const ADMIN_DELETE_DOCUMENT_SUCCESS = 'ADMIN_DELETE_DOCUMENT_SUCCESS';
export const ADMIN_DELETE_DOCUMENT_ERROR= 'ADMIN_DELETE_DOCUMENT_ERROR';

export const ADMIN_EDIT_DOCUMENT_REQUEST = 'ADMIN_EDIT_DOCUMENT_REQUEST';
export const ADMIN_EDIT_DOCUMENT_SUCCESS = 'ADMIN_EDIT_DOCUMENT_SUCCESS';
export const ADMIN_EDIT_DOCUMENT_ERROR= 'ADMIN_EDIT_DOCUMENT_ERROR';

export const ADMIN_GET_DOCUMENT_REQUEST = 'ADMIN_GET_DOCUMENT_REQUEST';
export const ADMIN_GET_DOCUMENT_SUCCESS = 'ADMIN_GET_DOCUMENT_SUCCESS';
export const ADMIN_GET_DOCUMENT_ERROR= 'ADMIN_GET_DOCUMENT_ERROR';

export const ADMIN_ADD_CATEGORY_REQUEST = 'ADMIN_ADD_CATEGORY_REQUEST';
export const ADMIN_ADD_CATEGORY_SUCCESS = 'ADMIN_ADD_CATEGORY_SUCCESS';
export const ADMIN_ADD_CATEGORY_ERROR = 'ADMIN_ADD_CATEGORY_ERROR';

export const ADMIN_DELETE_CATEGORY_REQUEST = 'ADMIN_DELETE_CATEGORY_REQUEST';
export const ADMIN_DELETE_CATEGORY_SUCCESS = 'ADMIN_DELETE_CATEGORY_SUCCESS';
export const ADMIN_DELETE_CATEGORY_ERROR= 'ADMIN_DELETE_CATEGORY_ERROR';

export const ADMIN_EDIT_CATEGORY_REQUEST = 'ADMIN_EDIT_CATEGORY_REQUEST';
export const ADMIN_EDIT_CATEGORY_SUCCESS = 'ADMIN_EDIT_CATEGORY_SUCCESS';
export const ADMIN_EDIT_CATEGORY_ERROR= 'ADMIN_EDIT_CATEGORY_ERROR';

export const ADMIN_GET_CATEGORY_REQUEST = 'ADMIN_GET_CATEGORY_REQUEST';
export const ADMIN_GET_CATEGORY_SUCCESS = 'ADMIN_GET_CATEGORY_SUCCESS';
export const ADMIN_GET_CATEGORY_ERROR= 'ADMIN_GET_CATEGORY_ERROR';

